module.exports = __webpack_public_path__ + "img/edc.cd1ab592.svg";